// extracted by mini-css-extract-plugin
module.exports = {"host":"InfoWidget_host__28xTH","icon":"InfoWidget_icon__14CEc","value":"InfoWidget_value__LzX39","title":"InfoWidget_title__1NXBi","progressbar":"InfoWidget_progressbar__36RKB"};